var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{staticClass:"pr-0",attrs:{"md":"2"}},[_c('canvas',{style:(_vm.style)})]),_c('b-col',{attrs:{"md":"10"}},[_c('div',[_vm._v(_vm._s(_vm.color.name))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }